<script>
    import * as api from '../../shared/api.js'
    
    export let item
    export let status
    export let active

    let working = false
    let logs    = null
    let error   = null

    $: loading = active && working

    $: if(active) {
        working = true
        api
            .get(`/inquiry/${item.inquiry.protocol}/source/${status.place.id}/logs`)
            .then(api.toTextIf200)
            .then(text => {
                working = false
                logs = text
            })
            .catch(e => {
                working = false
                error = e
            })
    } else {
        working = false
        logs = null
    }
</script>

<style>
    .logs {
        font-size: 80%;
        white-space: pre;
    }
</style>

<h4 class="ui header">Logs</h4>
<div class="ui segment">
    {#if logs}
        <div class="logs">
            {logs}
        </div>
    {:else}
        <div class="ui placeholder">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div>
    {/if}
</div>